import { MatDynamicRenderer } from "@/components/Mat";
import { OnboardingProgression } from "@/components/OnboardingProgression";
import Shimmer from "@/components/Shimmer";
import { HeaderTextBlock, TypographyContainer } from "@/components/Typography";
import { useOnboardingStatus } from "@/hooks/useOnboardingStatus";
import { useMatIntegrationConfiguration } from "@/requests/hooks/mat";
import stringToTitleCase from "@/utils/stringToTitleCase";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

const MatConfiguration = () => {
  const { integration } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    data: matIntegrationConfigurationData,
    isLoading: isMatIntegrationConfigurationLoading,
    isError: isMatIntegrationConfigurationError,
  } = useMatIntegrationConfiguration(integration!);
  const {
    onboardingStatus: { isOnboarding },
  } = useOnboardingStatus();

  if (isMatIntegrationConfigurationError) {
    navigate("/integrations/mat-settings?message=configuration_error");
    return;
  }

  const renderOnboardingProgression = () =>
    !!isOnboarding && (
      <div className="my-50">
        <OnboardingProgression currentStep="INSTALL_MAT_APP" enabled={true} />
      </div>
    );

  return (
    <>
      <TypographyContainer>
        <HeaderTextBlock
          featureText={t(
            "integrations.matSettings.authentication.header.feature",
          )}
          headingText={t(
            "integrations.matSettings.authentication.header.heading",
            { integration: stringToTitleCase(integration) },
          )}
        />
      </TypographyContainer>
      <div>
        <div>
          {isMatIntegrationConfigurationLoading ? (
            <Shimmer height={500} />
          ) : (
            <>
              <MatDynamicRenderer data={matIntegrationConfigurationData!} />
              {renderOnboardingProgression()}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default MatConfiguration;
